import { render } from "./ProductBatchForm.vue?vue&type=template&id=2409bf07&scoped=true"
import script from "./ProductBatchForm.vue?vue&type=script&lang=js"
export * from "./ProductBatchForm.vue?vue&type=script&lang=js"

import "./ProductBatchForm.vue?vue&type=style&index=0&id=2409bf07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2409bf07"]])

export default __exports__